/*
 * SWF实例创建
 * 修改SWFUpload原型链方法，集成列表功能
 * @description 请注意swfupload.js和swfupload.queue.js均修改过源码
 * @author sy
 * @date 2018-3-23
 */

import SWFUpload from './swfupload'
import './swfupload.queue'
import UploadList from '../upload_list/upload-list'
import {getTime} from '../utils'

window.SWFUpload = SWFUpload

let instance
let upFiles = [] // 上传文件集合
let begin // 上传开始时间
let errCode

/**
 * 从上传列表集合中获取文件
 * @param fid
 * @returns {*}
 */

function getFile (fid) {
  let target
  upFiles.every(item => {
    target = fid === item.id ? item : null
    return !target
  })
  return target
}

/**
 * 修改SWFUpload原型链fileDialogComplete
 * @param numFilesSelected
 * @param numFilesQueued
 * @param numFilesInQueue
 */

SWFUpload.prototype.fileDialogComplete = function (numFilesSelected, numFilesQueued, numFilesInQueue) {
  this.queueEvent('file_dialog_complete_handler', [numFilesSelected, numFilesQueued, numFilesInQueue])
  if (numFilesSelected !== 0) {
    if (location.href.indexOf('/link/view') <= -1 && localStorage.approveExist === 'true') {
      UploadList.prototype.listMaskShow() // 审批遮罩层
    } else {
      UploadList.prototype.listMaskHide() // 审批遮罩层隐藏
    }
    UploadList.prototype.show() // 打开列表
    begin = new Date().getTime() // 生成一个开始时间
  }
  if (errCode === -100) {
    UploadList.prototype.warn('queue_limit_warn', this.settings.file_queue_limit)
    // UploadList.prototype.warn('您一次最多只能添加' + instance.settings.file_queue_limit + '个文件！')
  } else {
    UploadList.prototype.clearWarn()
  }
}

/**
 * 修改SWFUpload原型链fileQueued
 * @param file
 */

SWFUpload.prototype.fileQueued = function (file) {
  file = this.unescapeFilePostParams(file)
  this.queueEvent('file_queued_handler', file)
  let f = Object.assign({}, file)
  f.percentage = 0
  f.time = '00:00:00'
  f.raw = file
  UploadList.prototype.add(f) // 列表添加数据
  upFiles.push(f)
  errCode = 0
}

/**
 * 修改SWFUpload原型链fileQueueError
 * @param file
 * @param errorCode
 * @param message
 */

SWFUpload.prototype.fileQueueError = function (file, errorCode, message) {
  file = this.unescapeFilePostParams(file)
  if (file) {
    let f = Object.assign({}, file)
    f.percentage = 0
    f.time = '00:00:00'
    f.raw = file
    UploadList.prototype.add(f) // 列表添加数据
    upFiles.push(f)
  }
  if (errorCode === -100) {
    errCode = errorCode
  } else {
    errCode = 0
  }
  // this.queueEvent('file_queue_error_handler', [file, errorCode, message])
  this.queueEvent('return_upload_queue_error_handler', [file, errorCode, message])
}

/**
 * 新增SWFUpload原型链returnUploadQueueError
 * @param file
 * @param errorCode
 * @param message
 */

SWFUpload.prototype.returnUploadQueueError = function (file, errorCode, message) {
  let returnValue = ''
  if (typeof this.settings.file_queue_error_handler === 'function') {
    file = this.unescapeFilePostParams(file)
    let res = this.settings.file_queue_error_handler.call(this, file, errorCode, message)
    returnValue = res
  } else if (this.settings.file_queue_error_handler != undefined) {
    throw 'file_queue_error_handler must be a function'
  }

  if (returnValue === undefined) {
    returnValue = ''
  }

  UploadList.prototype.error(returnValue, file)
}

/**
 * 修改SWFUpload原型链returnUploadStart
 * @param file
 */

/* eslint-disable */
SWFUpload.prototype.returnUploadStart = function (file) {
  let returnValue
  if (typeof this.settings.upload_start_handler === 'function') {
    file = this.unescapeFilePostParams(file)
    let res = this.settings.upload_start_handler.call(this, file)
    returnValue = res.result // important！！！
    if (!res.result) {
      UploadList.prototype.error(res.message, file)
    }
  } else if (this.settings.upload_start_handler != undefined) {
    throw 'upload_start_handler must be a function'
  }

  // Convert undefined to true so if nothing is returned from the upload_start_handler it is
  // interpretted as 'true'.
  if (returnValue === undefined) {
    returnValue = true
  }

  returnValue = !!returnValue

  if (!returnValue) {
    // 如果return false 取消当前文件上传，不触发error，同时返回值变为true，否则下一个文件不上传 真他妈奇葩的设计
    this.cancelUpload(file.id, false)
    returnValue = true
  }

  this.callFlash('ReturnUploadStart', [returnValue])
}

/**
 * 修改SWFUpload Queue原型链uploadStartHandler
 * @param file
 * @returns {*}
 */

SWFUpload.queue.uploadStartHandler = function (file) {
  let returnValue
  if (typeof(this.queueSettings.user_upload_start_handler) === "function") {
    returnValue = this.queueSettings.user_upload_start_handler.call(this, file)
  }

  // To prevent upload a real "FALSE" value must be returned, otherwise default to a real "TRUE" value.
  let res = (returnValue.result === false) ? false : true

  // 注释掉是因为该参数会导致upload_start_handler return false时 所有上传停止 真他妈奇葩的设计
  // this.queueSettings.queue_cancelled_flag = !res

  return returnValue
}

/**
 * 修改SWFUpload原型链uploadProgress
 * @param file
 * @param bytesComplete
 * @param bytesTotal
 */

SWFUpload.prototype.uploadProgress = function (file, bytesComplete, bytesTotal) {
  file = this.unescapeFilePostParams(file)
  this.queueEvent('upload_progress_handler', [file, bytesComplete, bytesTotal])
  let f = getFile(file.id)
  f.filestatus = file.filestatus
  f.modificationdate = file.modificationdate
  if (bytesTotal > 0) {
    if (bytesComplete > 0) {
      let now = new Date().getTime()
      let dValue = now - begin
      let res = bytesTotal / (bytesComplete / dValue) - dValue
      f.time = getTime(res)
    } else {
      f.time = '00:00:00'
    }
    f.percentage = bytesComplete / bytesTotal * 100
    UploadList.prototype.progress(f) // 上传改变文件显示
  }
}

/**
 * 修改SWFUpload原型链uploadSuccess
 * @param file
 * @param serverData
 * @param responseReceived
 */

SWFUpload.prototype.uploadSuccess = function (file, serverData, responseReceived) {
  file = this.unescapeFilePostParams(file)
  this.queueEvent('upload_success_handler', [file, serverData, responseReceived])
  let f = getFile(file.id)
  f.filestatus = file.filestatus
  f.modificationdate = file.modificationdate
  UploadList.prototype.success(f, upFiles)
}

/**
 * 修改SWFUpload原型链uploadError
 * @description 源码中传递upload_error_handler事件，修改后传递return_upload_error_handler
 * @param file
 * @param errorCode
 * @param message
 */

SWFUpload.prototype.uploadError = function (file, errorCode, message) {
  file = this.unescapeFilePostParams(file)
  // this.queueEvent('upload_error_handler', [file, errorCode, message])
  this.queueEvent('return_upload_error_handler', [file, errorCode, message])
}

/**
 * 新增SWFUpload原型链returnUploadError
 * @description 在upload_error_handler中返回一个错误提示在列表显示，如果没有返回值则使用默认提示语
 * @param file
 * @param errorCode
 * @param message
 */

/* eslint-disable */
SWFUpload.prototype.returnUploadError = function (file, errorCode, message) {
  let returnValue = ''
  if (typeof this.settings.upload_error_handler === 'function') {
    file = this.unescapeFilePostParams(file)
    let res = this.settings.upload_error_handler.call(this, file, errorCode, message)
    returnValue = res
  } else if (this.settings.upload_error_handler != undefined) {
    throw 'upload_error_handler must be a function'
  }

  if (returnValue === undefined) {
    returnValue = ''
  }

  UploadList.prototype.error(returnValue, file)
}

/**
 * 新增SWFUpload原型链checkUploadStatus
 * @description 因为引入了swfupload.queue.js，所以必须调用cancelQueue
 * @returns {boolean}
 */

SWFUpload.prototype.checkUploadStatus = function () {
  let res = true
  if (this.getStats().in_progress === 1) {

    if (window.confirm('确认取消所有未完成的任务?')) {
      this.cancelQueue() // swfupload.queue.js 会触发error，一个当前文件的stop和所有未传完的cancel（N+1）
      upFiles = [] // 关闭列表后则清空缓存
    } else {
      res = false
    }
  }
  return res
}

/**
 * 新增SWFUpload原型链listError
 * @param message
 * @param file
 */

SWFUpload.prototype.listError = function (message, file) {
  UploadList.prototype.error(message, file)
}

/**
 * 新增SWFUpload原型链给调用者一个直接调用上传列表的方法
 * @param message
 * @param file
 */

SWFUpload.prototype.listShow = function () {
    UploadList.prototype.show()
}

/**
 * 新增SWFUpload原型链listAdd，组件外调用者一个初始化列表内容的方法
 * @param message
 * @param file
 */

SWFUpload.prototype.listAdd = function (file) {
    UploadList.prototype.add(file)
}

/**
 * 新增SWFUpload原型链listClose，组件外关闭列表
 * @param message
 * @param file
 */

SWFUpload.prototype.listClose = function () {
  UploadList.prototype.closed()
}


export default function initSWF (options) {
  instance = new SWFUpload(options)
  return instance
}



// WEBPACK FOOTER //
// ./src/components/upload/upload_swf/index.js